import { render } from "./HackathonLocation.vue?vue&type=template&id=124db7a6"
import script from "./HackathonLocation.vue?vue&type=script&lang=js"
export * from "./HackathonLocation.vue?vue&type=script&lang=js"
script.render = render

export default script